import useragent from '@finance/useragent'
import { call } from '@common/client/src/bridge'

/**
 * 修复global-setting 未对卡牛做的兼容，解决埋点问题
 */
const init = () => {
  let timer: number
  return new Promise((resolve) => {
    if (useragent.isSuishouji) {
      console.log('[polyfill _ssjData] 随手记不需要兼容')
      resolve(null)
      return
    }
    if (!useragent.isKaniu) {
      console.log('[polyfill _ssjData] 非随手记，非卡牛，不需要兼容')
      window._ssjData = {
        ...window._ssjData,
      }
      resolve(null)
      return
    }
    timer = setTimeout(() => {
      console.log('[polyfill _ssjData] 初始化卡牛超时')
      resolve(null)
    }, 500)
    call('cardniu://api/getUserInfo', 'onGetUserInfo', (dataInfo: any) => {
      clearTimeout(timer)
      let client = dataInfo || {}
      if (typeof client !== 'object') {
        client = {}
      }
      window._ssjData = {
        ...window._ssjData,
        ...{
          appName: client.appCnName || 'cardniu',
          appVersion: client.version || '',
          UUID: client.UDID || '',
          deviceModel: client.deviceModel || '',
          networkType: client.networktype || client.netWorkType || '',
          osVersion: client.client_osversion || '',
          partnerCode: '',
          idfa: '',
          userId: client.unencrypted_userId || '',
        }
      }
      console.log('[polyfill _ssjData] 卡牛侧polyfill成功', window._ssjData)
      resolve(null)
    })
  })
}

export default init
